import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Typography } from 'antd';
import axios from 'axios';
import styled from 'styled-components';
import { useNotificationContext } from '@/features/notifications';
import { Col } from '@/shared/ui';
import { captureError } from '@/shared/utils/error-reporting';
import { config } from '@config';

const { Title, Text } = Typography;

export const Password = () => {
  const { user } = useAuth0();
  const { showNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(
    !user?.sub?.startsWith('auth0|') || false,
  );

  const handlePasswordReset = async () => {
    setLoading(true);
    const options = {
      method: 'POST',
      url: `https://${config.auth0.domain}/dbconnections/change_password`,
      headers: { 'content-type': 'application/json' },
      data: {
        client_id: config.auth0.clientId,
        email: user?.email,
        connection: 'Username-Password-Authentication',
      },
    };
    axios
      .request(options)
      .then(function (res) {
        if (res.status === 200) {
          setBtnDisabled(true);
          showNotification({
            type: 'success',
            message: 'Link sent',
            description:
              'An email with a link to reset your password has been sent to your email address. Check yout inbox.',
          });
          setLoading(false);
        }
      })
      .catch(function (error) {
        captureError(error, {
          module: 'password_on_error_handle_password_reset',
          action: 'handle_password_reset',
        });
        setLoading(false);
      });
  };

  return (
    <Col alignItems="flex-start">
      <Title level={3} style={{ marginBottom: 5 }}>
        Password
      </Title>
      <Subheading>
        {user?.sub?.startsWith('auth0|') ? (
          'Click button below to get an email with a link to reset your password.'
        ) : (
          <Col alignItems="flex-start">
            <Text>You are using a social account to login.</Text>{' '}
            <Text>
              You need to reset your password within social account provider
              settings.
            </Text>
          </Col>
        )}
      </Subheading>
      <Button
        type="primary"
        size="large"
        disabled={btnDisabled}
        loading={loading}
        onClick={handlePasswordReset}
        style={{ marginTop: 40 }}
      >
        Reset Password
      </Button>
    </Col>
  );
};

const Subheading = styled(Text)`
  opacity: 0.6;
`;
